import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobal } from "../../context/GlobalContext";
import { motion } from "framer-motion";
import { generateMasterplan } from "../../services/api";
import { useAuraVoice } from "../../hooks/useAuraVoice";
import Fireworks from "./Fireworks"; // adjust the path if needed
import "./Review.css";

// Importando os assets existentes
import Stars from "../../assets/stars.svg";
import Caldeirao from "../../assets/caldeirao.png";

const Review = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useGlobal();
  useAuraVoice("Show! Deixa eu dar uma olhada aqui nas suas respostas pra gente finalizar...", "reflection");

  const hasFetched = useRef(false);
  const [showFireworks, setShowFireworks] = useState(false);

  const STAGGER = 0.8;   // delay per card (index * STAGGER)
  const FALL_MS = 2000;  // y animation duration
  const FADE_MS = 2000;  // opacity animation duration

  // Mini cards que caem no caldeirão
  const fallingCards = [
    "Suas respostas",
    "Suas escolhas",
    "Seus dados",
    "Suas preferências",
    "Suas prioridades",
    "Seus desafios"
  ];

  // useEffect #1: Para buscar os dados da API (sem alterações)
  useEffect(() => {
    const executeTask = async () => {
      if (hasFetched.current) {
        return;
      }
      hasFetched.current = true;
      try {
        const masterplanData = {
          masterplan_id: state.masterplan_id,
          selected_pains: state.selected_pains,
          selected_goals: state.selected_goals,
          selected_functions: state.selected_functions,
        };
        dispatch({ type: "UPDATE_STATE", payload: { isLoading: true } });
        const response = await generateMasterplan(masterplanData);
        dispatch({ type: "FINAL_DRAFT_RESPONSE", payload: response });
      } catch (error) {
        console.error("Erro ao gerar o masterplan:", error);
        dispatch({
          type: "UPDATE_STATE",
          payload: { isLoading: false, error: "Falha ao processar." },
        });
        navigate("/");
      }
    };
    executeTask();
  }, [
    dispatch,
    navigate,
    state.masterplan_id,
    state.selected_goals,
    state.selected_functions,
    state.selected_pains,
  ]);

  // useEffect #2: Para navegar quando os dados chegarem (sem alterações)
  useEffect(() => {
    if (state.finalDraftReady) {
      navigate("/masterplan");
    }
  }, [state.finalDraftReady, navigate]);

  useEffect(() => {
    // total time until the last card is fully done:
    const lastIndex = fallingCards.length - 1;
    const totalMs = lastIndex * STAGGER * 1000 + FALL_MS + FADE_MS;

    const t = setTimeout(() => setShowFireworks(true), totalMs);
    const hide = setTimeout(() => setShowFireworks(false), totalMs + 2600); // auto-hide after burst
    return () => { clearTimeout(t); clearTimeout(hide); };
  }, [fallingCards.length]);

  return (
    <motion.div
              className="aura-container"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
      <img
        src={Stars}
        alt="Estrelas no céu"
        className="review-stars-background"
      />
      <main className="review-content">
        <h1 className="review-title">Revisando suas respostas...</h1>
      </main>
     
      {/* Container para os cards caindo */}
      <div className="falling-cards-container">
        {fallingCards.map((text, index, arr) => (
          <motion.div
            key={index}
            className="falling-card"
            style={{ zIndex: arr.length - index }}
            initial={{
              y: -300,
              x: 0,
              opacity: 1,
              rotate: 0
            }}
            animate={{
              y: window.innerHeight * 0.55,
              x: 0,
              opacity: [1, 1, 1, 0],
              rotate: [0, 5, -5, 0]
            }}
            transition={{
              delay: index * 1, // Delay moderado para todos os 6 cards aparecerem
              duration: 4,
              ease: "easeIn",
              opacity: {
                times: [0, 0.7, 0.9, 1],
                duration: 8
              },
              rotate: {
                duration: 6,
                ease: "easeInOut"
              }
            }}
          >
            {text}
          </motion.div>
        ))}
      </div>
     
      <img
        src={Caldeirao}
        alt="Caldeirão"
        className="review-caldeirao"
      />

      {showFireworks && (
        <Fireworks duration={4000} onDone={() => setShowFireworks(false)} />
      )}
    </motion.div>
  );
};

export default Review;

